import '../css/navbar.css';
import Drawer from '@material-ui/core/Drawer';
import { useState } from 'react';


function Navbar(props) {
    const [open, setOpen] = useState(false);  // for drawer componnent on mobile

    return (
        <div className='navbar-container'>
            <nav className={props.currentComponent !== 'home' ? 'navbar nav-colors' : 'navbar'}>
                <h2 className="logo">tyinteriors</h2>
                <svg onClick={() => setOpen(true)} height="32px" id="Layer_1" version="1.1" viewBox="0 0 32 32" width="32px" fill={props.currentComponent !== 'home' ? 'black' : 'white'} xmlns="http://www.w3.org/2000/svg"><path d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"/></svg>
                <ul>
                    <li className={props.currentComponent === 'home' ? 'underline-nav' : ''} onClick={() => props.setCurrentComponent('home')}>HOME</li>
                    <li className={props.currentComponent === 'portfolio' ? 'underline-nav' : ''} onClick={() => props.setCurrentComponent('portfolio')}>PORTFOLIO</li>
                    <li className={props.currentComponent === 'about' ? 'underline-nav' : ''} onClick={() => props.setCurrentComponent('about')}>ABOUT</li>
                    <li className={props.currentComponent === 'pricing' ? 'underline-nav' : ''} onClick={() => props.setCurrentComponent('pricing')}>PRICING</li>
                    <li className={props.currentComponent === 'contact' ? 'underline-nav' : ''} onClick={() => props.setCurrentComponent('contact')}>CONTACT</li>
                </ul>
            </nav>

            <Drawer open={open} anchor='right' onClose={() => setOpen(false)}>
                <div className="mobile-nav-space"></div>
                <h1 className="mobile-nav-header">tyinteriors</h1>
                <div style={{borderBottom: 'solid black 1px', width: '100%', height: '0.5em'}}></div>
                <ul className="mobile-nav">
                    <li className={props.currentComponent === 'home' ? 'bold-nav' : ''} onClick={() => props.setCurrentComponent('home')}>HOME</li>
                    <li className={props.currentComponent === 'portfolio' ? 'bold-nav' : ''} onClick={() => props.setCurrentComponent('portfolio')}>PORTFOLIO</li>
                    <li className={props.currentComponent === 'about' ? 'bold-nav' : ''} onClick={() => props.setCurrentComponent('about')}>ABOUT</li>
                    <li className={props.currentComponent === 'pricing' ? 'bold-nav' : ''} onClick={() => props.setCurrentComponent('pricing')}>PRICING</li>
                    <li className={props.currentComponent === 'contact' ? 'bold-nav' : ''} onClick={() => props.setCurrentComponent('contact')}>CONTACT</li>
                </ul>
            </Drawer>
        </div>
    );
}

export default Navbar;